import {AfterContentInit, AfterViewInit, Component, EventEmitter, Input, OnChanges, OnInit, Output, TemplateRef, ViewChild} from '@angular/core';
import {TranslateService} from '@ngx-translate/core';
import {BsModalRef, BsModalService} from 'ngx-bootstrap';

@Component({
  selector: 'app-confirmation-modal',
  templateUrl: './confirmation-modal.component.html'
})
export class ConfirmationModalComponent implements AfterContentInit {
  @Input() public title: string;
  @Input() public level: string;
  public btnLevel: string;
  @Input() public text: string;
  @Input() public id: any;
  @Input() public confirm: string;
  @Input() public decline: string;
  @Input() public size: string = 'modal-sm';
  @ViewChild('confirmationModal') template: TemplateRef<any>;
  @Output() public confirmation: EventEmitter<{confirmed: boolean, id: any, data: any}> = new EventEmitter();
  private customData: any;
  private modalRef: BsModalRef;

  constructor(
    private modalService: BsModalService,
    private translate: TranslateService
  ) {}

  ngAfterContentInit(): void {
    if(!this.title) {
      this.translate.get('confirmation.title').subscribe((translation) => {
        this.title = translation;
      });
    }

    if(!this.text) {
      this.translate.get('confirmation.text').subscribe((translation) => {
        this.text = translation;
      });
    }

    if(!this.confirm) {
      this.translate.get('confirmation.confirm').subscribe((translation) => {
        this.confirm = translation;
      });
    }

    if(!this.decline) {
      this.translate.get('confirmation.decline').subscribe((translation) => {
        this.decline = translation;
      });
    }

    if(!this.level) {
      this.level = 'warning';
    }
    this.btnLevel = `btn-${this.level}`;
  }

  public show(customData: any) {
    this.customData = customData;
    this.modalRef = this.modalService.show(this.template, this.size);
  }

  public doConfirm() {
    this.confirmation.emit({confirmed: true, id: this.id, data: JSON.parse(JSON.stringify(this.customData))});
    this.customData = undefined;
    this.modalRef.hide();
  }

  public doDecline() {
    this.confirmation.emit({confirmed: false, id: this.id, data: JSON.parse(JSON.stringify(this.customData))});
    this.customData = undefined;
    this.modalRef.hide();
  }

}



// WEBPACK FOOTER //
// /var/jenkins_home/workspace/brands-compart-portal-frontend/checkout/src/app/components/confirmation/confirmation-modal.component.ts